<app-loading-spinner
  *ngIf="loadingSpinnerService.loading$ | async"></app-loading-spinner>
<div class="tab-content notifications-main">
  <img class="empty-not-img" src="../../assets/images/empty-notifications.svg" alt="" />
  <h2>There’s no notifications, yet</h2>
  <p>
    Managing your notifications is super simple, so, why don’t you start
    creating now?
  </p>

  <button
    class="hover-button create-btn"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#collapseExample"
    aria-expanded="false"
    aria-controls="collapseExample">
    <img src="../../assets/images/add.svg" alt="" /> Create new notification
  </button>

  <div
    class="collapse collapse-horizontal new-notification"
    id="collapseExample"
    #notificationExpand
    (shown.bs.collapse)="toggleBackdrop(true)"
    (hidden.bs.collapse)="toggleBackdrop(false)">
    <div class="new-notification-top">
      <h3>New notification</h3>
      <div class="d-flex align-items-center">
        <h3 [style.color]="businessData.remainingNotificationsCount === 0 ? 'rgba(255, 105, 105, 1)' : 'rgba(0, 131, 172, 1)'">{{businessData.remainingNotificationsCount}} notifications left</h3>
        <h4>Resets on {{resetDate}}</h4>
        <button data-bs-toggle="collapse" data-bs-target="#collapseExample">
          <img src="../../assets/images/close-notification.svg" alt="" />
        </button>
      </div>
    </div>

    <div class="new-notification-bottom">
      <form class="d-flex flex-column justify-content-between h-100" [formGroup]="notificationForm" (ngSubmit)="sendNotification()">
        <div>
          <div class="mb-3 input-wrapper">
            <label for="notificationTitle" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Title
            </label>
            <input
              type="text"
              class="form-control"
              id="notificationTitle"
              placeholder="ex. Special Occasions, Extraordinary Celebrations!"
              formControlName="notificationTitle"
              maxlength="30"/>
  
            <div
              *ngIf="notificationTitle.invalid && notificationTitle.touched"
              class="text-danger"></div>
  
            <span
              class="text-limit"
              [ngClass]="{
                'max-characters': notificationTitle.value?.length === 30}">max 30</span>
          </div>
  
          <div class="mb-3 input-wrapper">
            <label for="notificationDetails" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Notification
              details
            </label>
            <textarea
              class="form-control"
              id="notificationDetails"
              rows="3"
              placeholder="Short description"
              formControlName="notificationDetails"
              maxlength="500"
            ></textarea>
  
            <div
              *ngIf="notificationDetails.invalid && notificationDetails.touched"
              class="text-danger"></div>
  
            <span
              class="text-limit"
              [ngClass]="{
                'max-characters': notificationDetails.value?.length === 500
              }"
              >max 500</span>
          </div>
  
          <div class="mb-3 input-wrapper">
            <label for="findOutMoreLink" class="form-label"
              >Find Out More Link <span class="fw-normal">(optional)</span></label
            >
            <input
              type="url"
              class="form-control"
              id="findOutMoreLink"
              placeholder="https://gullimagnets.com"
              formControlName="findOutMoreLink"
            />
  
            <div
              *ngIf="findOutMoreLink.invalid && findOutMoreLink.touched"
              class="text-danger"
            >
              <small class="url-error" *ngIf="findOutMoreLink.errors?.['pattern']"
                >Please enter a valid URL.</small
              >
            </div>
          </div>
  
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <div
              #mediaLabel
                class="nav-link"
                id="pills-media-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-media"
                type="button"
                role="tab"
                aria-controls="pills-media"
                aria-selected="true"
              >
                <img src="../../../assets/images/media.svg" alt="" />
                <h3>Media</h3>
                <p>
                  You can include up to 5 photos, and videos to enhance your
                  notifications.
                </p>
              </div>
            </li>
            <li class="nav-item" role="presentation">
              <div
                class="nav-link"
                id="pills-pdf-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-pdf"
                type="button"
                role="tab"
                aria-controls="pills-pdf"
                aria-selected="false"
              >
                <img src="../../../assets/images/pdf.svg" alt="" />
                <h3>PDF</h3>
                <p>
                  You can include up to 5 photos, and videos to enhance your
                  notifications.
                </p>
              </div>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
  
            <!-- Media Upload Section -->
            <label
            #mediaUploadButton
              for="media"
              class="tab-pane fade"
              id="pills-media"
              role="tabpanel"
              aria-labelledby="pills-media-tab"
              [ngClass]="{ disabled: pdfUploaded }"
              *ngIf="!mediaUploaded"
            >
              <img *ngIf="!pdfUploaded" src="../../../assets/images/media.svg" alt="" />
              <h3 *ngIf="!pdfUploaded">Click <span>here</span> to upload your media</h3>
              <p *ngIf="!pdfUploaded">
                You can upload up to 5 photos and videos up to 30 seconds long.
                <br />
                Ideally, the dimensions should be in a portrait aspect ratio.
              </p>
              <p *ngIf="pdfUploaded" class="error-message">
                You've already uploaded a PDF file. 
                Please delete it to upload your media and send it to your audience.
              </p>
            </label>
            <input
            type="file"
            style="visibility: hidden; height: 0"
            id="media"
            accept="image/png, image/gif, image/jpeg, video/mp4"
            (change)="onMediaChange($event, 'media')"
            multiple
            [disabled]="pdfUploaded"
          />
  
            <!-- PDF Upload Section -->
            <label
              class="tab-pane fade mb-2"
              id="pills-pdf"
              role="tabpanel"
              aria-labelledby="pills-pdf-tab"
              for="pdf"
              [ngClass]="{ disabled: mediaUploaded }"
              *ngIf="!pdfUploaded"
            >
              <img *ngIf="!mediaUploaded" src="../../../assets/images/pdf.svg" alt="" />
              <h3 *ngIf="!mediaUploaded">Click <span>here</span> to upload your PDF file</h3>
              <p *ngIf="!mediaUploaded">
                You can upload your file in .pdf format for sharing promotions,
                new offers, posters, and more.
              </p>
              <p *ngIf="mediaUploaded" class="error-message">
                You've already uploaded a Media file. 
                Please delete it to upload your PDF and send it to your audience.
              </p>
              <input
                type="file"
                style="visibility: hidden; height: 0"
                id="pdf"
                accept="application/pdf"
                (change)="onMediaChange($event, 'pdf')"
                [disabled]="mediaUploaded"
              />
            </label>
          </div>
  
          <div class="selected-media" *ngIf="selectedMedia.length > 0">
            <ul>
              <li
                *ngFor="let file of selectedMedia; let i = index"
                [ngClass]="{ 'invalid-file': file.invalid }">
                <div class="selected-info">
                  <img
                    *ngIf="file.thumbnail"
                    [src]="file.thumbnail"
                    alt="Selected media"/>
                  <img
                    *ngIf="!file.thumbnail && file.invalid"
                    src="../../../assets/images/not-supported-file.svg"
                    alt="Selected media" />
                  <div>
                    <p>
                      {{ file.name }}
                    </p>
                    <small *ngIf="!file.invalid">
                      {{ (file.size / (1024 * 1024)).toFixed(2) }} MB
                    </small>
                    <small *ngIf="file.invalid"> {{ file.errorMessage }} </small>
                  </div>
                </div>
                <button
                  class="border-0 bg-transparent hover-button"
                  (click)="removeFile(i)">
                  <img
                    src="../../../assets/images/TrashSimple.svg"
                    alt="Delete"/>
                </button>
              </li>
            </ul>
            <!-- "Add more" button only visible for media, and not shown if PDF is uploaded -->
            <button type="button"
              class="send-notification hover-button mb-2"
              *ngIf="selectedMedia.length < 5 && !pdfUploaded">
              <label class="text-white" for="media">+ Add more</label>
            </button>
          </div>
        </div>
        <div class="submit-wrapper">
          <button type="submit" class="submit-btn hover-button" [disabled]="!notificationForm.valid || !mediaValid || this.businessData.remainingNotificationsCount === 0">Send</button>
          <button type="button" class="cancel-btn" (click)="notificationForm.reset()" data-bs-toggle="collapse" data-bs-target="#collapseExample">Cancel</button>
        </div>
      </form>
    </div>
  </div>
  <div
    class="sidebar-backdrop"
    data-bs-toggle="collapse"
    data-bs-target="#collapseExample"
    #backdrop></div>
</div>


<!-- Toast container -->
<!-- Add #notificationToast reference -->
<div  #notificationToast class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="d-flex">
    <div class="toast-body">
      Notification sent successfully!
    </div>
  </div>
</div>

<!-- Error Toast -->
<div #errorToast class="toast align-items-center text-bg-danger border-0" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="d-flex">
    <div class="toast-body">
      There was an error uploading your media. Please try again.
    </div>
  </div>
</div>
